/* <section-carousel>: wraps a Swiper instance configured by the JSON in [data-carousel-options]. */

if (!window.__sectionCarouselSwiperLoaders) window.__sectionCarouselSwiperLoaders = {};

function loadSwiper(src) {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (!src) return Promise.reject(new Error('Swiper source is missing'));

  const loaders = window.__sectionCarouselSwiperLoaders;
  if (!loaders[src]) {
    loaders[src] = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => (window.Swiper ? resolve(window.Swiper) : reject(new Error('Swiper not found')));
      script.onerror = () => reject(new Error('Swiper failed to load'));
      document.head.appendChild(script);
    });
  }
  return loaders[src];
}

if (!customElements.get('section-carousel')) {
  customElements.define(
    'section-carousel',
    class SectionCarousel extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      async init() {
        const container = this.querySelector('.swiper');
        const optionsEl = this.querySelector('[data-carousel-options]');
        if (!container || !optionsEl) return;

        let options;
        try {
          options = JSON.parse(optionsEl.textContent);
        } catch (error) {
          return;
        }

        let Swiper;
        try {
          Swiper = await loadSwiper(this.dataset.swiperSrc);
        } catch (error) {
          return;
        }
        if (!this.isConnected || this.swiper) return;

        const { showNavigation, showPagination, ...swiperOptions } = options;
        const paginationEl = this.querySelector('[data-carousel-pagination]');
        if (showPagination && paginationEl) {
          swiperOptions.pagination = { el: paginationEl, clickable: true };
        }
        if (!swiperOptions.autoplay) delete swiperOptions.autoplay;

        this.swiper = new Swiper(container, swiperOptions);
      }

      destroy() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
